
import * as Project from "./projectStyles";

import { FaGithub, FaExternalLinkAlt } from "react-icons/fa"


export default function ProjectItemSmall({ project }){
    return (
        <Project.ItemInner  data-aos="fade-up">
            <Project.ItemSnapshot src={project.photoUrl} />
            <Project.InfoContainerSmall>
                    <Project.DescriptionContainerSmall>
                
                    <Project.ItemNameSmall>{project.title}</Project.ItemNameSmall>
                    
                    <Project.LinkSmall href={project.github} target="_blank"><FaGithub /></Project.LinkSmall>
                    {
                        project.website ? 
                        <Project.LinkSmall href={project.website} target="_blank"><FaExternalLinkAlt/></Project.LinkSmall> : 
                        null
                    }

                    <Project.FeaturedTextSmall>Feature Project</Project.FeaturedTextSmall>
                    <Project.DescriptionText>{project.description}</Project.DescriptionText>
                    
                    <Project.TechnologiesContainerSmall>
                        {project.technologies &&
                            project.technologies.map((item, index) =>
                            <Project.TechnologiesTextSmall key={index}>{item}</Project.TechnologiesTextSmall>

                        )}
                    </Project.TechnologiesContainerSmall>
                </Project.DescriptionContainerSmall>
            </Project.InfoContainerSmall>
        </Project.ItemInner>

    )
}